export default "__VITE_ASSET__e249c88f__"